export default __webpack_public_path__ + "static/media/harbinger-systems-whitelogo.d8324cda.png";